import axios from "axios";
import config from "./config";
import {getCookie} from "./app/common/appCookie";
import {CONSTANTS} from "./app/common/constants";

const axiosInstance = axios.create({
  baseURL: config.api.ENDPOINT,
  responseType: "json",
  withCredentials: true
});

axiosInstance.interceptors.request.use(
  config => {
    config.headers['X-PSB-CID'] = getCookie(CONSTANTS.PSB_CID);
    config.headers['X-PSB-UID'] = getCookie(CONSTANTS.PSB_UID);
    config.headers['X-PSB-SID'] = getCookie(CONSTANTS.PSB_SID);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
